import { Box, useTheme } from "@mui/material"
import { SelectionOptions } from "../../shared/SelectionOptions"
import { categoryItems } from "../../shared/sharedHelper"
import { useAppSelector } from "../../../redux/hooks";
import { commonState } from "../../../redux/common/commonSlice";
import { OptionProps } from "@sis/react-library";
import { RefreshButton } from "../../shared/RefreshButton";
import { trackState } from "../../../redux/track/trackSlice";
import { ActionBarSelectInput } from "../../shared/ActionBarSelectInput";

interface TrackPageActionsProps {
    providerCode: string;
    categoryCode: string;
    onProviderCodeChange: (searchProviderCode: string) => void;
    onCategoryCodeChange: (searchCategoryCode: string) => void;
    onRefresh: () => void;
}

export const TrackPageActions = ({
    providerCode, categoryCode, onProviderCodeChange, onCategoryCodeChange, onRefresh
}: TrackPageActionsProps) => {

    const common = useAppSelector(commonState);
    const state = useAppSelector(trackState);
    const theme = useTheme();

    const providerOptions: OptionProps[] = common.providers.map((s) => (
        { value: s.code, description: s.description })
    );

    // allow parameter to be any
    // eslint-disable-next-line
    const handleProviderCodeChange = (e: any) => {
        onProviderCodeChange(e.target.value);
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '5px' }}>
            <Box sx={{ display: 'flex', marginTop: '-10px' }}>
                <ActionBarSelectInput
                    id="actions-provider"
                    value={providerCode}
                    options={providerOptions}
                    width="150px"
                    onChange={handleProviderCodeChange}
                />
            </Box>
            <Box sx={{ display: 'flex', padding: '6px 6px 0 12px' }}>
                <SelectionOptions
                    id="actions-category"
                    items={categoryItems}
                    value={categoryCode}
                    onValueChange={(code) => onCategoryCodeChange(code)}
                />
            </Box>
            <Box sx={{ paddingTop: '6px', marginRight: '-4px' }}>
                <RefreshButton
                    id='actions-refresh'
                    tooltip="Refresh Track Codes"
                    loading={state.loading}
                    colour={theme.palette.primary.main}
                    onClick={onRefresh}
                />
            </Box>
        </Box>
    )
}
